module.exports = __webpack_public_path__ + "img/nature-travel.beada15d.webp";